export const NAME_STRING_MAX_LENGTH = 64;
export const DESCRIPTION_STRING_MAX_LENGTH = 64;

export const DEFAULT_STRING_MAX_LENGTH = 512;
export const FIELD_REQUIRED = 'Field is required';
export const VALUE_TOO_LONG = 'Value in this field is too long';
export const REGEXP_NOT_MATCHES = "Value doesn't match given pattern";
